import { useState } from 'react';
import './contact.css';
import api from '../../api/axios';
import { useTranslation } from 'react-i18next';

const ContactForm = () => {

    const { t } = useTranslation();
    // Variablen für das Formular
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    const sendContactForm = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post("/user/contact", {
                name,
                email,
                subject,
                message
            });

            setModalMessage(res.data.message || "Nachricht erfolgreich gesendet.");
            setIsModalOpen(true);
            setName('');
            setEmail('');
            setSubject('');
            setMessage('');
        } catch (err) {
            console.error("Fehler beim Senden:", err);
            setModalMessage("Fehler beim Senden der Nachricht.");
            setIsModalOpen(true);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalMessage('');
    };

    return (
        <div>
            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close-button" onClick={closeModal}>&times;</span>
                        <p>{modalMessage}</p>
                    </div>
                </div>
            )}
            <form onSubmit={sendContactForm} className="contact-form">
                <input
                    type="text"
                    className="input-field-cf"
                    name="name"
                    placeholder={t('Name')}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <input
                    type="email"
                    className="input-field-cf"
                    name="email"
                    placeholder={t('ContactMailAddress')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    type="text"
                    className="input-field-cf"
                    name="subject"
                    placeholder={t('Topic')}
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                />
                <textarea
                    className="input-field-cf textarea-field"
                    name="message"
                    placeholder={t('ContactMessage')}
                    maxLength="1000"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <button type="submit" className="btn" id="contact-form-submit-btn">{t('SendMessage')}</button>
            </form>
        </div>
    );
};

export default ContactForm;